module.exports = __webpack_public_path__ + "static/badminton-9f808197d1780d91528371a83502c2c0.svg";